module.exports = __webpack_public_path__ + "img/bannernoimage.6a1353cb.svg";